import { render, staticRenderFns } from "./form_Task.vue?vue&type=template&id=23fefc76&scoped=true"
import script from "./form_Task.vue?vue&type=script&lang=js"
export * from "./form_Task.vue?vue&type=script&lang=js"
import style0 from "./form_Task.vue?vue&type=style&index=0&id=23fefc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fefc76",
  null
  
)

export default component.exports